import _ from 'lodash';
import { EventEmitter } from 'events';
import AppDispatcher from '../dispatcher/AppDispatcher';
import BankTransferConstants from '../constants/BankTransferConstants';

let _status = {};
let _requests = {};
let _progress = {};
let _errorCodes = {};
let _errorShortIds = {};

const BankTransferStore = _.extend({}, EventEmitter.prototype, {
	getStatus: function (booking_id) {
		return _status[booking_id] || BankTransferConstants.STATUS.INITIAL;
	},

	getRequest: function (booking_id) {
		return _requests[booking_id] || null;
	},

	getProgress: function (booking_id) {
		return _progress[booking_id] || 0;
	},

	getErrorCode: function (booking_id) {
		return _errorCodes[booking_id] || null;
	},

	getErrorShortId: function (booking_id) {
		return _errorShortIds[booking_id] || null;
	},

	emitChange: function () {
		this.emit('change');
	},

	addChangeListener: function (callback) {
		this.on('change', callback);
	},

	removeChangeListener: function (callback) {
		this.removeListener('change', callback);
	},
});

AppDispatcher.register(function (payload) {
	let action = payload.action;

	switch (action.actionType) {
		case BankTransferConstants.BANK_TRANSFER_LOADING:
			(action.data.booking_ids || []).forEach((booking_id) => {
				_status[booking_id] = BankTransferConstants.STATUS.BUSY;
				_progress[booking_id] = 0;
				delete _errorCodes[booking_id];
				delete _errorShortIds[booking_id];
			});
			break;

		case BankTransferConstants.BANK_TRANSFER_PROGRESS:
			(action.data.booking_ids || []).forEach((booking_id) => {
				_progress[booking_id] = action.data.progress;
			});
			break;

		case BankTransferConstants.BANK_TRANSFER_SUCCESS:
			(action.data.booking_ids || []).forEach((booking_id) => {
				_status[booking_id] = BankTransferConstants.STATUS.SUCCESS;
				if (action.data.request) {
					_requests[booking_id] = action.data.request;
				}
			});
			break;

		case BankTransferConstants.BANK_TRANSFER_FAILED:
			(action.data.booking_ids || []).forEach((booking_id) => {
				_status[booking_id] = BankTransferConstants.STATUS.FAILED;
				_errorCodes[booking_id] = action.data.error_code || null;
				_errorShortIds[booking_id] = action.data.error_short_id || null;
			});
			break;

		case BankTransferConstants.BANK_TRANSFER_RESET:
			(action.data.booking_ids || []).forEach((booking_id) => {
				delete _status[booking_id];
				delete _requests[booking_id];
				delete _progress[booking_id];
				delete _errorCodes[booking_id];
				delete _errorShortIds[booking_id];
			});
			break;

		default:
			return true;
	}

	// If action was responded to, emit change event
	BankTransferStore.emitChange();

	return true;
});

export default BankTransferStore;
